import React, { useState, useRef, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useDropzone } from "react-dropzone";
import { ListGroup, Form, Row, Col, InputGroup, Button } from "react-bootstrap";
import {
  IconPhotoPlus,
  IconTrash,
  IconLink,
  IconEye,
  IconEdit,
  IconDownload,
} from "@tabler/icons-react";
import axios from "axios"; // or use any other method to call your API
import { toast } from "react-toastify";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS, trimText } from "../../../constant/_constant";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const IMG = process.env.REACT_APP_BASE_URL_IMG;

const FileUpload = ({
  attachmnetid,
  moduleType,
  maxFiles = 20,
  maxFileSize = 20,
  onFilesChange,
}) => {
  const [listingData, setListingData] = useState([]);
  const [files, setFiles] = useState([]);
  const [maxFilesLimit, setMaxFilesLimit] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const IMG = process.env.REACT_APP_BASE_URL_IMG;

  const [editableNames, setEditableNames] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);

  const handleNameChange = (e, index) => {
    const newValue = e.target.value;

    setEditableNames((prev) => ({
      ...prev,
      [index]: newValue, // Directly update the editable name value
    }));
  };



  const handleNameSubmit = (index, extension, id) => {
    const editedName = editableNames[index]?.trim();
    if (!editedName) return;

    const newFullName = `${editedName}${extension}`;
    const payload = {
      name: newFullName,
      module_type: "RFQ",
      id: id,
    };

    const onUpdateNameSuccess = () => {
      fetchFiles({ attachment_id: attachmnetid });
      setEditableNames((prev) => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
      setEditingIndex(null);
    };
    updateName(payload, onUpdateNameSuccess);
  };

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [formDataLink, setFormDataLink] = useState({
    link: "",
    displayText: "",
  });
  const [errors, setErrors] = useState({
    link: "",
    displayText: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataLink({
      ...formDataLink,
      [name]: value,
    });
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let errorMsg = "";
    if (name === "link") {
      if (!value) {
        errorMsg = "Link is required";
      } else if (!/^https?:\/\/[^\s$.?#].[^\s]*$/.test(value)) {
        errorMsg = "Please enter a valid URL";
      }
    }
    if (name === "displayText") {
      if (value.length > 100) {
        errorMsg = "Display text should not exceed 100 characters";
      }
    }
    setErrors({
      ...errors,
      [name]: errorMsg,
    });
  };

  const onSuccessIMG = (res) => {
    fetchFiles({ attachment_id: attachmnetid });
  };

  const onErrorIMG = (error) => {
    toast.error(error.message);
  };

  const onSuccessLink = (res) => {
    fetchFiles({ attachment_id: attachmnetid });
  };
  const onErrorLink = (error) => {
    toast.error(error.message);
  };

  const onRemoveSuccess = (response) => {
    toast.success(response.message);
    fetchFiles({ attachment_id: attachmnetid });
  };
  const onRemoveError = (error) => {
    toast.error(error.message || "An error occurred during removing file.");
  };

  const { isLoading, postData: uploadFiles } = usePostRequest(
    API_ENDPOINTS.UPLOAD_ATTACHMENTS_PUBLICRMA
  );

  const { data: fetchLink, postData: GetAttachment } = usePostRequest(
    API_ENDPOINTS.VIEW_ATTACHMENT_PUBLICRMA
  );

  const {
    isLoading: fetchLoading,
    data: attachmentData,
    postData: fetchFiles,
  } = usePostRequest(API_ENDPOINTS.FETCH_ATTACHMENTS_PUBLICRMA);

  const {
    isLoading: nameLoading,
    data: UpdateNameData,
    postData: updateName,
  } = usePostRequest(API_ENDPOINTS.UPDATENAME_ATTACHMENT_PUBLICRMA);

  const { isLoading: removeLoading, postData: remove_Attachment } =
    usePostRequest(API_ENDPOINTS.REMOVE_ATTACHMENT_PUBLICRMA);

  useEffect(() => {
    fetchFiles({ attachment_id: attachmnetid });
  }, [attachmnetid]);

  const removeFile = (id, Filetype) => {
    remove_Attachment(
      { id: id, type: Filetype },
      onRemoveSuccess,
      onRemoveError
    );
  };

  const handleDrop = async (acceptedFiles) => {
    if (files.length + acceptedFiles.length > maxFiles) {
      setMaxFilesLimit(`You can only upload up to ${maxFiles} files.`);
      return;
    }

    const newFiles = [...files, ...acceptedFiles];
    setFiles(newFiles);
    if (onFilesChange) onFilesChange(newFiles);
    const formData = new FormData();
    if (acceptedFiles && acceptedFiles.length > 0) {
      acceptedFiles.forEach((file, index) => {
        formData.append("attachments", file);
      });
    }
    formData.append("type", "IMAGE");
    formData.append("module_type", moduleType);
    formData.append("attachment_id", attachmnetid);
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
    await uploadFiles(
      formData,
      onSuccessIMG,
      onErrorIMG,
      API_ENDPOINTS.UPLOAD_ATTACHMENTS_PUBLICRMA
    );
  };
  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: "image/*,application/pdf",
    maxFiles,
  });

  const downloadImage = async (e, item) => {
    e.preventDefault();

    const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
    const customFileName = item.original_name;

    try {
      const response = await fetch(imageUrl, {
        method: "GET",
      });

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", customFileName || "download.jpg");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isFormValid = Object.values(errors).every((error) => error === "");
    if (isFormValid) {
      const formData = new FormData();
      formData.append("type", "LINK");
      formData.append("module_type", moduleType);
      formData.append("attachment_id", attachmnetid);
      formData.append("display_text", formDataLink.displayText);
      formData.append("file_name", formDataLink.link);
      uploadFiles(
        formData,
        onSuccessLink,
        onErrorLink,
        API_ENDPOINTS.UPLOAD_ATTACHMENTS_PUBLICRMA
      );
    } else {
      console.log("Form is invalid");
    }
  };

  const openModal = (id, Filetype) => {
    let modalMessage = "Are you sure you want to delete this Image?";
    let modalTitle = "Delete Image";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let actionHandler = () => {
      removeFile(id, Filetype);
    };
    let action = "delete";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  useEffect(() => {
    if (fetchLink?.data) {
      window.open(fetchLink.data, "_blank");
    }
  }, [fetchLink]);

  const viewAttachment = async (e, attachmentId) => {
    e.preventDefault();
    try {
      await GetAttachment({ id: attachmentId });
    } catch (error) {
      console.error("Failed to view attachment", error);
    }
  };

  return (
    <>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      <Form.Group className="mb-3">
        <Form.Label>Attachments</Form.Label>
        <div
          className="fileUpload"
          {...getRootProps({ className: "dropzone" })}
        >
          <p>
            <span className="d-block">
              <IconPhotoPlus stroke={1} />
            </span>
            Max file size: {maxFileSize} MB
            <br />
            <span className="click_file" onClick={handleBrowseClick}>
              Add attachment
            </span>
          </p>
        </div>
        <input
          {...getInputProps()}
          ref={fileInputRef}
          style={{ display: "none" }}
        />
        <Form.Text className="text-danger">{maxFilesLimit}</Form.Text>
      </Form.Group>
      <Row>
        <Form>
          <Row>
            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label>Search or Paste a Link</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="link"
                    value={formDataLink.link}
                    onChange={handleChange}
                    placeholder="Find recent link or paste a new link"
                  />
                  <InputGroup.Text>
                    <IconLink stroke={1} />
                  </InputGroup.Text>
                </InputGroup>
                {errors.link && (
                  <small className="text-danger">{errors.link}</small>
                )}
              </Form.Group>
            </Col>

            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label>Display text (optional)</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="displayText"
                    value={formDataLink.displayText}
                    onChange={handleChange}
                    placeholder="Text to display"
                  />
                </InputGroup>
                {errors.displayText && (
                  <small className="text-danger">{errors.displayText}</small>
                )}
              </Form.Group>
            </Col>

            <Col md={2}>
              <Form.Group>
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="warning"
                  className="w-100"
                  disabled={Object.values(errors).some((error) => error !== "")}
                  onClick={handleSubmit}
                >
                  Insert
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Row>

      {fetchLoading ? (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <>
          {attachmentData?.data?.length > 0 && (
            <>
              <div className="mb-2">
                <b> Attachments </b>
              </div>
              <ListGroup className="mb-3">
                {attachmentData?.data.map((file, index) => {
                  const isImage = file.type === "IMAGE";
                  const rawName = file.original_name;

                  let nameOnly = rawName;
                  let extension = "";

                  if (isImage) {
                    const fileParts = rawName.split(".");
                    nameOnly = fileParts.slice(0, -1).join(".");
                    extension = "." + fileParts[fileParts.length - 1];
                  }

                  return (
                    <ListGroup.Item
                      key={index}
                      className="d-flex align-items-center justify-content-between gap-5"
                    >
                      {editingIndex === index ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            className="form-control flex-1"
                            value={editableNames[index] !== undefined ? editableNames[index] : nameOnly}
                            onChange={(e) => handleNameChange(e, index)}
                            autoFocus
                          />
                          <span style={{ marginLeft: 4 }}>{extension}</span>
                        </div>
                      ) : (
                        <span>
                          {file.type === "LINK"
                            ? file.original_name
                              ? `${trimText(file.file_name, 50)} (${file.original_name
                              })`
                              : file.file_name
                            : editableNames[index] || file.original_name}
                        </span>
                      )}

                      {editingIndex !== index ? (
                        <div className="attetchment_icons">
                          {file.type === "IMAGE" && (
                            <span
                              className="text-blue"
                              onClick={(e) => downloadImage(e, file)}
                            >
                              <IconDownload />
                            </span>
                          )}

                          {file.type === "LINK" ? (
                            <a
                              className="text-blue"
                              href={`${file.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <IconEye />
                            </a>
                          ) : (
                            <span
                              className="text-blue"
                              // href={`${IMG}uploads/attachments/${file.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                viewAttachment(e, file?.id)
                              }}
                            >
                              <IconEye />
                            </span>
                          )}

                          <span
                            className="trash_files text-danger"
                            onClick={() => openModal(file.id, file.type)}
                          >
                            <IconTrash />
                          </span>

                          <span
                            className="text-muted ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => setEditingIndex(index)}
                          >
                            <IconEdit />
                          </span>
                        </div>
                      ) : (
                        <div className="attetchment_icons">
                          <span
                            className="btn btn-6 btn-success w-100"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleNameSubmit(
                                index,
                                extension,
                                file.id,
                                file.type
                              )
                            }
                          >
                            Save
                          </span>
                          <span
                            className="btn btn-6 btn-danger w-100"
                            style={{ cursor: "pointer" }}
                            onClick={() => setEditingIndex(null)} // Cancel the editing
                          >
                            Cancel
                          </span>
                        </div>
                      )}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </>
          )}
          {attachmentData?.data.length === 0 && (
            <Form.Text>No files selected.</Form.Text>
          )}
        </>
      )}
    </>
  );
};

export default FileUpload;
